@if (!isAccepted) {
  <div class="form-check my-3">
    <label class="form-check-label">
      <input class="form-check-input" type="checkbox" [formControl]="inputIsAccepted" value="">
      Estoy de acuerdo en que puedo cumplir con estas expectativas
    </label>
    <button type="button" class="mt-4 btn btn-primary btn-lg btn-block" (click)="onAcceptance()" [disabled]="!inputIsAccepted.value || isLoading">
      Aceptar y Continuar
      @if (isLoading) {
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      }
    </button>
  </div>
}